import React, { useEffect, useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Container, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Alert } from '@mui/material';
import { getLeaderboard } from '../services/vtradingApi';
import { useTranslation } from 'react-i18next';

const pinkTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#e91e63' },
    background: { default: '#fff0f6' },
  },
});

export default function VLeaderboardPage() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getLeaderboard()
      .then(setData)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <ThemeProvider theme={pinkTheme}>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ bgcolor: 'background.default', p: 3, borderRadius: 2 }}>
          <Typography variant="h4" gutterBottom color="primary">
            {t('vleaderboard.title')}
          </Typography>
          {loading && <CircularProgress />}
          {error && <Alert severity="error">{error}</Alert>}
          {data && (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t('vleaderboard.rank')}</TableCell>
                    <TableCell>{t('vleaderboard.publicName')}</TableCell>
                    <TableCell align="right">{t('vleaderboard.portfolioValue')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.leaderboard.map((u, i) => (
                    <TableRow key={u.user_id}>
                      <TableCell>{i + 1}</TableCell>
                      <TableCell>{u.public_name}</TableCell>
                      <TableCell align="right">${u.value.toLocaleString(undefined, { maximumFractionDigits: 2 })}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Container>
    </ThemeProvider>
  );
} 